import { forwardRef } from "react";
import { ContainerToPreview, Container } from "./styles";

const ComponentToPreview = forwardRef((props, ref) => {
  return (
    <Container>
      <ContainerToPreview ref={ref}>{props.children}</ContainerToPreview>;
    </Container>
  );
});

export default ComponentToPreview;
